<template>
  <div>
    <JqxWindow ref="myWindow" :theme="'material'" :width="930" :height="650" :resizable="true" :isModal="true"
               :autoOpen="false" :initContent="init">
      <div class="col-md"><strong>Impianti</strong>
      </div>
      <div>
        <JqxTabs ref="tab" :theme="'material'" :animationType="'fade'" :autoCreate="false">
          <ul id="muoviti" style="margin-left: 5px">
            <li>Dati generali</li>
            <li>Extra</li>
          </ul>
          <div>
            <JqxSplitter ref="splitter" :width="850" :heigth="600" :autoCreate="false" :panels="panels">
              <div class="splitter-panel" :theme="'material'">
                <PlaceAutoGoogleWithoutMaps ref="autogoogle"></PlaceAutoGoogleWithoutMaps>
              </div>
              <div class="splitter-panel">
                <div style="margin-top: 5px;margin-left: 5px;">
                  <div class="form-group">
                    <label>Tipo picking</label>
                    <br>
                    <JqxComboBox :autoDropDownHeight="true" :selectedIndex="0" ref="tipo_picking" :popupZIndex="10000" :displayMember="'descrizione'" :valueMember="'id'" :source="dataAdapterTipopicking" :theme="'material'"></JqxComboBox>
                  </div>
                  <div class="form-group">
                    <label>Codice opzionale</label>
                    <br>
                    <JqxInput :theme="'material'" ref="codice_opzionale"></JqxInput>
                  </div>

                  <div class="form-group row">
                    <div class="col-md-6">
                      <label>Indirizzo e-mail</label>
                      <br>
                      <JqxInput :theme="'material'" ref="email"></JqxInput>
                    </div>
                    <div class="col-md-6">
                      <label>telefono</label>
                      <br>
                      <JqxInput :theme="'material'" ref="telefono"></JqxInput>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-md-6">
                      <label>Partita iva</label>
                      <br>
                      <JqxInput :theme="'material'" ref="partita_iva"></JqxInput>
                    </div>
                    <div class="col-md-6">
                      <label>Codice fiscale</label>
                      <br>
                      <JqxInput :theme="'material'" ref="codice_fiscale"></JqxInput>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Tipo documento di trasporto</label>
                    <br>
                    <JqxComboBox :autoDropDownHeight="true" :selectedIndex="0" :popupZIndex="10000" :displayMember="'descrizione'" :valueMember="'id'" :source="dataAdapterTipoDocumenti" :theme="'material'" ref="tipo_documento_trasporto"></JqxComboBox>
                  </div>

                  <div class="form-group">
                    <label>Invio movimentazioni</label>
                    <br>
                    <JqxCheckBox :theme="'material'" :width="120" :height="25"
                                 ref="invio_movimentazioni">
                    </JqxCheckBox>
                  </div>
                </div>
              </div>
            </JqxSplitter>
          </div>
          <div>
            <div class="form-group">
              <label>Note interne</label>
              <br>
              <JqxInput :theme="'material'" ref="note_interne"></JqxInput>
            </div>
          </div>
        </JqxTabs>
        <card>
          <div class="float-right">
            <JqxButton :theme="'material'" @click="saveParent">
              Save
            </JqxButton>

            <JqxButton :theme="'material'" @click="cancelParent">
              Cancel
            </JqxButton>
          </div>
        </card>
      </div>
    </JqxWindow>
  </div>

</template>

<script>
  import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
  import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
  import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
  import PlaceAutoGoogleWithoutMaps from '.././google/PlaceAutoGoogleWithoutMaps';
  import JqxSplitter from '~jqx/jqwidgets-vue/vue_jqxsplitter.vue';
  import JqxTabs from '~jqx/jqwidgets-vue/vue_jqxtabs.vue';
  import JqxComboBox from "~jqx/jqwidgets-vue/vue_jqxcombobox.vue";
  import JqxCheckBox from "~jqx/jqwidgets-vue/vue_jqxcheckbox.vue";

  export default {
    name: "ImpiantiDetails",
    components: {
      JqxInput,
      JqxNumberInput,
      JqxButton,
      JqxWindow,
      PlaceAutoGoogleWithoutMaps,
      JqxSplitter,
      JqxTabs,
      JqxComboBox,
      JqxCheckBox

    },
    data: function () {
      return {
        panels: [{size: 200}, {size: 200}],
        dataAdapterTipoDocumenti: new jqx.dataAdapter(this.sourcetipodocumenti),
        dataAdapterTipopicking: new jqx.dataAdapter(this.sourcetipopicking)
      }
    },
    beforeCreate: function () {
      this.sourcetipodocumenti = {
        datatype: 'json',
        datafields: [
          {name: 'descrizione'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaTipoDocumenti&q=allforsourceinput'
      };
      this.sourcetipopicking = {
        datatype: 'json',
        datafields: [
          {name: 'descrizione'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaTipoPicking&q=allforsourceinput'
      };
    },
    methods: {
      saveParent() {
        this.$parent.saveBtn();
      },
      init: function () {
        let options = {height: "80%", theme: "material"};
        this.$refs.tab.createComponent(options);
        //this.$refs.splitter.panels =[{ size: 400 },{ size: 400 }];
        let tmp = {width: "98%", height: "98%", theme: "material"};
        this.$refs.splitter.createComponent(tmp);
      },
        cancelParent() {
        this.$parent.cancelBtn();
      },
    },
    mounted: function () {

    }
  }
</script>

<style scoped>
  .jqx-splitter {
    border: none;
  }
</style>
